module.exports = __webpack_public_path__ + "img/left.ab949830.jpg";